export default __webpack_public_path__ + "assets/img/Logo_WeltSparen_homepage.svg";